// Abertura da gaveta de dinheiro via QZ Tray (https://qz.io) — um agente
// gratuito instalado no PC do caixa. O PDV manda o comando de abrir a
// gaveta pra ele por WebSocket local (localhost), e o QZ Tray entrega
// direto pra fila de impressão do Windows como trabalho RAW, na mesma
// impressora térmica já usada pra imprimir o cupom.
//
// POR QUE NÃO WEBUSB (jeito antigo desse arquivo): o Chrome bloqueia por
// segurança qualquer site que tente controlar via WebUSB um dispositivo
// USB de classe "Impressora" — erro "The requested interface implements
// a protected class". É uma trava do próprio navegador (não depende do
// driver instalado no Windows, não tem workaround), então não tinha como
// funcionar com impressora térmica nenhuma. Confirmado em produção em
// 31/08/2026 (loja Mercado Ângelo, impressora XP-80C/POS80).
//
// REQUISITO: QZ Tray instalado e ABERTO no computador do caixa
// (qz.io/download — fica rodando na bandeja do Windows) e a impressora
// térmica já instalada normalmente no Windows.
import qz from 'qz-tray';
import api from '../services/api';

const LS_KEY_IMPRESSORA = 'pdv_gaveta_impressora';

// ESC p 0 25 250 — comando drawer-kick padrão ESC/POS, suportado pela
// imensa maioria das impressoras térmicas com gaveta ligada nela.
const HEX_ABRIR_GAVETA = '1B700019FA';

// Assina cada conexão com o certificado do backend (backend/src/controllers/
// qzController.js) — sem isso o QZ Tray trata a conexão como "anônima" e
// desabilita "Remember this decision" no popup de permissão, obrigando o
// operador a clicar Allow em toda venda em dinheiro. A chave privada nunca
// sai do servidor; só a assinatura de cada requisição trafega.
let seguracaConfigurada = false;
function configurarSeguranca() {
  if (seguracaConfigurada) return;
  seguracaConfigurada = true;
  qz.security.setSignatureAlgorithm('SHA512');
  qz.security.setCertificatePromise((resolve, reject) => {
    api.get('/qz/certificate', { responseType: 'text', transformResponse: r => r })
      .then(r => resolve(r.data))
      .catch(reject);
  });
  qz.security.setSignaturePromise(toSign => (resolve, reject) => {
    api.post('/qz/sign', { toSign })
      .then(r => resolve(r.data.signature))
      .catch(reject);
  });
}

export function gavetaSuportada() {
  // QZ Tray funciona em qualquer navegador (Chrome, Edge, Firefox), desde
  // que o programa esteja instalado e rodando no PC.
  return true;
}

export async function conectar() {
  configurarSeguranca();
  if (qz.websocket.isActive()) return;
  try {
    await qz.websocket.connect();
  } catch {
    throw new Error(
      'QZ Tray não está rodando neste computador — instale em qz.io/download e deixe aberto (ícone na bandeja do Windows), depois tente de novo.'
    );
  }
}

export function impressoraGavetaSalva() {
  return localStorage.getItem(LS_KEY_IMPRESSORA) || '';
}

export async function temImpressoraConfigurada() {
  return !!impressoraGavetaSalva();
}

// Lista as impressoras instaladas no Windows (via QZ Tray) — usado na tela
// de configuração pra o operador escolher qual delas tem a gaveta ligada.
export async function listarImpressoras() {
  await conectar();
  return qz.printers.find();
}

export function salvarImpressoraGaveta(nome) {
  localStorage.setItem(LS_KEY_IMPRESSORA, nome);
}

// ── Impressão direta (Ctrl+F12 → Opções → Impressão Direta) ────────────
// Mesma ideia da gaveta, só que pra mandar cupom/DANFE térmico direto pra
// fila de impressão (sem o diálogo "Imprimir" do navegador), via o mesmo
// QZ Tray/certificado já usado acima. É opt-in e por computador (fica no
// localStorage deste navegador, igual à impressora da gaveta) — configura
// uma vez em cada PC que quiser isso ligado; nos demais continua saindo
// pelo window.print() de sempre, sem nenhuma mudança de comportamento.
const LS_KEY_IMPRESSORA_IMPRESSAO = 'pdv_impressao_impressora';
const LS_KEY_IMPRESSAO_DIRETA     = 'pdv_impressao_direta';

// Sem impressora própria escolhida ainda, usa a mesma da gaveta — é o caso
// mais comum (uma térmica só faz tudo). Só precisa configurar separado se
// a loja imprime em impressoras diferentes.
export function impressoraImpressaoSalva() {
  return localStorage.getItem(LS_KEY_IMPRESSORA_IMPRESSAO) || impressoraGavetaSalva();
}
export function salvarImpressoraImpressao(nome) {
  localStorage.setItem(LS_KEY_IMPRESSORA_IMPRESSAO, nome);
}
export function impressaoDiretaAtiva() {
  return localStorage.getItem(LS_KEY_IMPRESSAO_DIRETA) === 'true';
}
export function salvarImpressaoDireta(ativa) {
  localStorage.setItem(LS_KEY_IMPRESSAO_DIRETA, ativa ? 'true' : 'false');
}

// Chamado a partir de um clique do operador (botão "Configurar Gaveta").
export async function abrirGaveta() {
  const nome = impressoraGavetaSalva();
  if (!nome) {
    throw new Error('Nenhuma impressora configurada pra gaveta — configure em ⚙️ Configurar Gaveta.');
  }
  await conectar();
  const config = qz.configs.create(nome);
  await qz.print(config, [{ type: 'raw', format: 'hex', data: HEX_ABRIR_GAVETA }]);
}
